<div class="subheader with-padding flgrow">
    <div class="row">
        <div class='col-lg-3 col-md-3 col-sm-6'>
            <div class="date">
                <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                [(ngModel)]="bookingDate" (ngModelChange)="onDateRangeChanged($event)" required/>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 relative mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
            <button type="submit" (click)="onClickChangeView(false)"
                [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
                translate>lblSATodayView
            </button>
            <button (click)="onClickChangeView(true)"
                [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class=""
                translate>lblSAWeekView
            </button>
            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                (click)='refresh()'>
                <em class="fas fa-sync font15 align-middle"></em>
            </a>
        </div>
        <div class="font16 fontbold" style="margin-left: auto;">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;<span
                class="font16 fontnormal" translate>lblResults</span>
        </div>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-12 mb15">
            <nav ngbNav #nav="ngbNav" [destroyOnHide]="false" (navChange)="switchTabs($event.nextId)">
                <ng-container ngbNavItem="QueueTab">
                    <button translate ngbNavLink>
                        lblQueue
                    </button>
                    <ng-template ngbNavContent>
                        <div class="card">
                            <div class="mt-3">
                                <div class="table-responsive  max-h232" infinite-scroll
                                    [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                                    [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                    <table class="tablest1">
                                        <thead>
                                            <tr>
                                                <th scope="col" style="width: 55px">#</th>
                                                <th scope="col" sortable="dmsName" (sort)="onSort($event)" translate>
                                                    lblDMSName
                                                </th>
                                                <th scope="col" sortable="tableName" (sort)="onSort($event)"style="width: 200px" translate>lblFeatureName
                                                </th>
                                                <th scope="col" translate>lblActionType</th>
                                                <th scope="col" translate>lblReferenceNo</th>
                                                <th scope="col" sortable="createdDate" (sort)="onSort($event)"
                                                    translate>lblCreatedDate
                                                </th>
                                                <th scope="col" sortable="processDate" (sort)="onSort($event)"
                                                translate>lblProcessDate
                                            </th>
                                                <th scope="col" translate>lblStatus</th>

                                                <th class="text-center" scope="col" translate>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngIf="dMSQueueLogList?.length>0; else load_else">
                                                <tr *ngFor="let log of dMSQueueLogList; let i=index">
                                                    <td>{{ i+1 }}</td>
                                                    <td>
                                                        <ngb-highlight [result]="log.dmsName">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.tableName">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.actionType">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.no_">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.createdDate | date : 'short'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.processDate | date : 'short'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.statusText">
                                                        </ngb-highlight>
                                                    </td>

                                                    <td class="nowrap text-center">

                                                        <a class="ml-2 btn btn-ico" ngbTooltip="{{'lblViewException' | translate}}"
                                                            tooltipClass="custom-revert" (click)="viewException(log)"
                                                            translate *ngIf="userRoleRightsDetails.canView">
                                                            <em class="fa fa-eye fa-lg"></em>
                                                        </a>
                                                        <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                                                        <a class="btn btn-ico " ngbTooltip="{{'lblDelete' | translate}}"
                                                            (click)="onDelete(log.rowId,'Queue')"
                                                            tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete">
                                                            <em class="far fa-trash-alt fa-lg"></em>
                                                        </a>
                                                    </td>

                                                </tr>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container ngbNavItem="HistoryTab">
                    <button ngbNavLink translate>
                        lblQueueHistory
                    </button>
                    <ng-template ngbNavContent>
                        <div class="card">
                            <div class="mt-3">
                                <div class="table-responsive  max-h232" infinite-scroll
                                    [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                                    [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                    <table class="tablest1">
                                        <thead>
                                            <tr>
                                                <th scope="col" style="width: 55px">#</th>
                                                <th scope="col" sortable="dmsName" (sort)="onSort($event)" translate>
                                                    lblDMSName
                                                </th>
                                                <th scope="col" sortable="tableName" (sort)="onSort($event)"style="width: 200px" translate>lblFeatureName
                                                </th>
                                                <th scope="col" translate>lblActionType</th>
                                                <th scope="col" translate>lblReferenceNo</th>
                                                <th scope="col" sortable="createdDate" (sort)="onSort($event)"
                                                    translate>lblCreatedDate
                                                </th>
                                                <th scope="col" sortable="processDate" (sort)="onSort($event)"
                                                    translate>lblProcessDate
                                                </th>
                                                <th scope="col" translate>lblStatus</th>

                                                <th class="text-center" scope="col" translate>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngIf="dMSQueueLogList?.length>0; else load_else">
                                                <tr *ngFor="let log of dMSQueueLogList; let i=index">
                                                    <td>{{i+1 }}</td>
                                                    <td>
                                                        <ngb-highlight [result]="log.dmsName">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.tableName">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.actionType">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.no_">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.createdDate | date : 'short'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.processDate | date : 'short'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="log.statusText">
                                                        </ngb-highlight>
                                                    </td>

                                                    <td class="nowrap text-center">

                                                        <a class="btn btn-ico " ngbTooltip="{{'lblDelete' | translate}}"
                                                            (click)="onDelete(log.rowId,'History')"
                                                            tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete">
                                                            <em class="far fa-trash-alt fa-lg"></em>
                                                        </a>
                                                    </td>

                                                </tr>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </nav>
            <div [ngbNavOutlet]="nav"></div>
        </div>
    </div>
</div>